
import { useState } from "react";
import { useLocation } from "react-router-dom";

export interface NavigationItem {
  name: string;
  path: string;
}

export const useNavigation = () => {
  const location = useLocation();
  
  const mainNavItems: NavigationItem[] = [
    { name: "Avaleht", path: "/" },
    { name: "Minust", path: "/about" },
    { name: "Coaching", path: "/coaching" },
    { name: "Kursused", path: "/courses" },
    // Teenused handled separately
    // Kontakt at the end
  ];

  const serviceNavItems: NavigationItem[] = [
    { name: "Somaatiline enesejuhtimise coaching", path: "/somatic-coaching" },
    { name: "Hüpnoteraapia", path: "/hypnotherapy" },
    { name: "Koolitused ja meeskonnacoaching", path: "/trainings" },
  ];
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const isServiceActive = () => {
    const servicePaths = ["/offerings", "/hypnotherapy", "/trainings", "/somatic-coaching"];
    return servicePaths.includes(location.pathname);
  };

  return {
    mainNavItems,
    serviceNavItems,
    isActive,
    isServiceActive,
  };
};
